import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import { ICellVerifyForm } from '@shared/core/components/cellVerify';

import { Observable } from 'rxjs';
import { AuthTypeComponent } from '../auth-type.shared.component';

@Component({
    selector: 'shared-auth-for-email-verify',
    templateUrl: './auth-for-email-verify.shared.component.html',
    styleUrls: ['./auth-for-email-verify.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthForEmailVerifyComponent extends AuthTypeComponent implements OnInit, OnDestroy {
    public email$: Observable<string>;
    public loading$: Observable<OLO.Components.LOADING_STATUS>;
    public isSendingToken$: Observable<boolean>;
    public canOmmitEmailVerification$: Observable<boolean>;

    constructor(
        public controllers: Controllers,
    ) {
        super(controllers);
    }

    ngOnInit(): void {
        this.email$ = this.controllers.members.getObfuscatedEmail$();
        this.canOmmitEmailVerification$ = this.controllers.members.canOmmitEmailVerificationStep$();
        this.loading$ = this.controllers.members.validateEmailStatus$();
        this.isSendingToken$ = this.controllers.members.isSendingEmailToken$();
    }

    ngOnDestroy(): void {
        this.controllers.members.restoreEmailVerificationFlags();
    }

    public handleResendClick($event: Event): void {
        this.controllers.members.resendVerificationEmail(true);
    }

    public handleEmailVerifyComplete($event: ICellVerifyForm): void {
        this.controllers.members.continueEmailVerification();
    }
}
